import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import BlogForm from '../components/blog/BlogForm';

const EditBlogPage = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await api.get(`/api/blog/${id}`);
        setPost(res.data);
      } catch (err) {
        console.error('Error al cargar post:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [id]);

  if (loading) return <div className="p-6 text-gray-600">Cargando publicación...</div>;

  if (!post) return <div className="p-6 text-red-500">No se encontró la publicación</div>;

  return <BlogForm initialData={post} />;
};

export default EditBlogPage;
